import { Record, Map as ImmutableMap, List } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import PropertyAssignment from 'automation-ui-action-features/object-type-properties/PropertyAssignment';
import AssociationUpdate from 'automation-ui-action-features/object-type-properties/AssociationUpdate';
import * as CreateObjectActionMetadataKeys from 'automation-ui-action-features/actions/create-object/constants/CreateObjectActionMetadataKeys';
import uniqueId from 'transmute/uniqueId';
import get from 'immutable-less/transmute/get';
export default class CreateObjectActionMetadata extends Record({
  [CreateObjectActionMetadataKeys.ACTION_TYPE]: ActionTypes.CREATE_OBJECT,
  [CreateObjectActionMetadataKeys.OBJECT_TYPE_ID]: null,
  [CreateObjectActionMetadataKeys.PROPERTIES]: null,
  [CreateObjectActionMetadataKeys.ASSOCIATIONS]: List(),
  [CreateObjectActionMetadataKeys.USE_EXPLICIT_ASSOCIATIONS]: true,
  [CreateObjectActionMetadataKeys.LINE_ITEMS]: []
}, 'CreateObjectActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const properties = propMap.get(CreateObjectActionMetadataKeys.PROPERTIES) || [];
    const associations = propMap.get(CreateObjectActionMetadataKeys.ASSOCIATIONS) || [];
    const lineItems = propMap.get(CreateObjectActionMetadataKeys.LINE_ITEMS) || [];
    super(propMap.set(CreateObjectActionMetadataKeys.PROPERTIES, List(properties.map(property => new PropertyAssignment(property)))).set(CreateObjectActionMetadataKeys.ASSOCIATIONS, List(associations.map(assoc => new AssociationUpdate(assoc)))).set(CreateObjectActionMetadataKeys.LINE_ITEMS, lineItems.map(lineItem => {
      const objectId = get('objectId', lineItem);
      return Object.assign({}, lineItem, {
        objectId: objectId || Number(uniqueId('-'))
      });
    })));
  }
  getAssociations() {
    return this.get(CreateObjectActionMetadataKeys.ASSOCIATIONS);
  }
  setAssociations(newAssociations) {
    return this.set(CreateObjectActionMetadataKeys.ASSOCIATIONS, List(newAssociations));
  }
  addAssociation(newAssociation) {
    return this.update(CreateObjectActionMetadataKeys.ASSOCIATIONS, associations => associations.push(newAssociation || new AssociationUpdate({
      targetSpec: undefined,
      value: {
        type: 'COPY_ASSOCIATION'
      }
    })));
  }
  deleteAssociation(index) {
    return this.update(CreateObjectActionMetadataKeys.ASSOCIATIONS, associations => associations.delete(index));
  }
  setAssociation(index, newAssociation) {
    return this.update(CreateObjectActionMetadataKeys.ASSOCIATIONS, associations => associations.set(index, newAssociation));
  }
  getLineItems() {
    return this.get(CreateObjectActionMetadataKeys.LINE_ITEMS);
  }
  getLineItemsCount() {
    return this.getLineItems().length;
  }
  setLineItems(newLineItems) {
    return this.set(CreateObjectActionMetadataKeys.LINE_ITEMS, newLineItems);
  }
  getPropertyAssignments() {
    return this.get(CreateObjectActionMetadataKeys.PROPERTIES);
  }
  setPropertyAssignments(propertyAssignments) {
    return this.set(CreateObjectActionMetadataKeys.PROPERTIES, propertyAssignments);
  }
}